import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const useOutsideClick = (onOutsideClick, outerRef) => {
  const innerRef = useRef()
  const ref = outerRef || innerRef

  const handleOutsideClick = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      if (onOutsideClick) {
        onOutsideClick(event)
      }
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  })

  return ref
}

useOutsideClick.propType = {
  handleOutsideClick: PropTypes.func,
}

export default useOutsideClick
